import { TableCell } from "@mui/material"
import type { ReactElement } from "react"

interface ProductOriginGridValuesProps {
  productOrigin: {
    country: string
    region: string
    city: string
    address?: string | null
  }
  testIdPrefix: string
}

export const ProductOriginGridValues = ({
  productOrigin,
  testIdPrefix,
}: ProductOriginGridValuesProps): ReactElement => {
  return productOrigin.address ? (
    <TableCell colSpan={3} data-testid={`${testIdPrefix}-address`}>
      {productOrigin.address || "-"}
    </TableCell>
  ) : (
    <>
      <TableCell data-testid={`${testIdPrefix}-country`}>{productOrigin.country || "-"}</TableCell>
      <TableCell data-testid={`${testIdPrefix}-region`}>{productOrigin.region || "-"}</TableCell>
      <TableCell data-testid={`${testIdPrefix}-city`}>{productOrigin.city || "-"}</TableCell>
    </>
  )
}
